import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';

@Injectable({ providedIn: 'root' })
export class PreProcurementCreateGuard implements CanActivate {
  private readonly allowedRoles = ['ORGANISATION-ADMIN', 'ACCOUNT-ADMIN'];

  constructor(private storageService: StorageService, private router: Router) {}

  canActivate(): boolean {
    if (this.allowedRoles.includes(this.storageService.getRole() || '')) {
      return true;
    }

    this.router.navigate(['/doqfy/pre-procurement/procurement-listing'], {
      state: { accessDenied: true },
    });
    return false;
  }
}
